export default __webpack_public_path__ + "static/media/refresh.2e0fe4a6.svg";